const header = [
  {
    text: "Início",
    needs_company: true,
    icon: "mdi-home",
    to: "/"
  },
  {
    text: "Agenda",
    needs_company: true,
    icon: "mdi-calendar",
    to: "/events"
  },
  {
    text: "Financeiro",
    needs_company: true,
    icon: "mdi-cash-check",
    to: "/financial"
  },
  {
    text: "Estatísticas",
    needs_company: true,
    icon: "mdi-chart-areaspline-variant",
    to: "/statistics"
  },
  {
    text: "Negociações",
    needs_company: true,
    icon: "mdi-swap-horizontal-bold",
    to: "/negotiations"
  }
// name 	teste
// email 	tst@tst.com
// password 	159753
// password_confirmation 	159753
];

const bottom = [
  {
    text: "Configurações",
    needs_company: true,
    icon: "mdi-domain",
    to: "/my_company"
  },
  // {
  //   text: "Equipe",
  //   needs_company: true,
  //   icon: "mdi-account-group",
  //   to: "/members"
  // },
];

const userTop = [
  {
    text: "Empresas",
    icon: "mdi-domain",
    to: "/"
  },
];

const super_admin_only = [
  {
    text: "Administração",
    needs_company: true,
    icon: "mdi-cog-box",
    to: "/admin_control"
  },
];

const userBottom = [
];
export { header, bottom, userBottom, userTop, super_admin_only};
